$(function () {
    $('.LpHomeTestimonialsCarousel').owlCarousel({
        loop: true,
        nav: true,
        items: 1,
        dots: false,
        navText: [
            '<svg class="icon-chevron-left text-primary"><use xlink:href="#icon-chevron-left"></use></svg>',
            '<svg class="icon-chevron-right text-primary"><use xlink:href="#icon-chevron-right"></use></svg>'
        ],
        margin: 15,
        stageClass: 'owl-stage d-flex',
        responsive: {
            0: {
                items: 1
            },
            667: {
                items: 2
            },
            992: {
                items: 3
            }

        }
    });
});